import { useEffect } from 'react';
/**
 * A hook that debounces an effect.
 * @param effect - The effect to debounce.
 * @param delay - The delay in milliseconds.
 * @param deps - The dependencies to watch.
 * @returns void.
 */
export const useDebouncedEffect = (effect, delay, deps) => {
    useEffect(() => {
        const timer = setTimeout(() => effect(), delay);
        return () => clearTimeout(timer);
    }, deps);
};
